/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lg-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;padding:32px 32px 24px 20px;gap:24px}"];
export { styles as styles };
